export default "__VITE_ASSET__BoiqiRZ4__"